module.exports = __webpack_public_path__ + "img/score_bg1.dd327ec.png";